import { ReactElement } from 'react';
import styled, { StyledComponent } from 'styled-components';

interface ClickableEle {
  onClick?: () => void;
  children?: Array<HTMLElement | ReactElement | string> | string;
  style?: React.CSSProperties;
}

// common
export const SubTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.88);
`;

export const MainTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const MainActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 1600px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const MainTitle = styled.div`
  font-size: 24px;
  color: #494949;
  font-weight: lighter;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

// Head
export const HomePage = styled.div`
  min-width: 1280px;
  position: relative;

  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MakeDefaultAndQuickStart = styled.span<ClickableEle>`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  display: inline-block;
`;

export const HomeHead = styled.div`
  background: #fff;
`;

export const Welcome = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #000;
  padding: 12px 0 16px;
`;

export const WelcomeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

// Quick Start
export const QuickStartSection = styled.div`
  width: 100%;
  padding: 16px 16px 0;
  a {
    color: #0046ff;
  }
`;

export const QuickStartHead = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const QuickStartContent = styled.div`
  display: flex;
`;

export const QuickStartContentText = styled.div`
  position: relative;
  flex: 1;
  background: #fff;
  margin-right: 12px;
  padding: 24px 16px;
  border-radius: 4px;
  border: #d9d9d9 solid 1px;
`;

export const QuickStartContentTextTitle = styled.div`
  font-size: 24px;
  color: #494949;
  line-height: 120%;
`;

export const QuickStartContentTextContent = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  padding: 10px 0;
`;

export const QuickStartContentVideo = styled.div`
  flex: 0;
`;

export const QuickStartLink = styled.div`
  font-size: 14px;
`;

export const Close = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
  cursor: pointer;
`;

// Capability
export const CapabilitySection = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  flex-direction: column;
  a {
    color: #0046ff;
  }
`;

export const KnowYourDataSectionContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  @media (min-width: 1440px) {
    width: 100%;
  }
  @media (min-width: 1600px) {
    margin-left: 8px;
    width: 460px;
  }
`;

export const CapabilityCardContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-top: 12px;
  flex-direction: row;
`;

export const ActivationSectionContainer = styled.div`
  flex: 1;
`;

export const MoreFeatures = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  margin-top: 16px;
  font-weight: bold;
`;

export const ActivateCard = styled.div`
  border-radius: 4px;
  border: #d9d9d9 solid 1px;
  background: #fff;
  padding: 16px 16px 24px 16px;
  width: calc((100% - 16px) / 3);
`;

export const CapabilityCardTitle = styled.div`
  font-size: 24px;
  color: #494949;
  font-weight: lighter;
  margin-top: -6px;
`;

export const CapabilityCardDesc: StyledComponent<'div', any> = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  padding-bottom: 16px;
`;

export const CapabilityCardLinkList = styled.ul`
  font-size: 14px;
  color: #0046ff;
  padding-left: 20px;
  li {
    line-height: 30px;
  }
`;

export const Line = styled.div`
  background-color: #d9d9d9;
  height: 1px;
  width: 100%;
  margin: 16px 0;
`;

// know your data
export const KnowYourDataContainer = styled.div`
  flex-direction: row;
  display: flex;
  gap: 8px;
  flex: 1;
  @media (min-width: 1600px) {
    flex-direction: column;
    justify-content: space-between;
    margin-top: 12px;
  }
`;

export const KnowYourDataItem = styled.div<ClickableEle>`
  width: 440px;
  height: 100%;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;

  border-radius: 4px;
  border: #d9d9d9 solid 1px;
  &:hover {
    background: #e6edff;
    border: 2px solid #0046ff;
  }
  @media (min-width: 1600px) {
    width: 100%;
    height: calc((100% - 8px) / 2);
  }
`;

export const KnowYourDataItemTitle = styled.div`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.88);
`;

export const KnowYourDataItemContent = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
`;

// footer
export const Footer = styled.div`
  color: rgba(0, 0, 0, 0.88);
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

export const FooterText = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-size: 12px;
  background: #fff;
  padding: 8px 0;
`;
